import React, { useState } from "react";
import "./ManageCategories.scss";

import CategoriesTab from "./CattTab/CategoriesTab";
import SubcategoriesTab from "./CattTab/SubcategoriesTab";
import SubSubcategoriesTab from "./CattTab/SubSubcategoriesTab";

const ManageCategories = () => {
  const [activeTab, setActiveTab] = useState("categories");

  const renderContent = () => {
    switch (activeTab) {
      case "categories":
        return <CategoriesTab />;
      case "subcategories":
        return <SubcategoriesTab />;
      case "subsubcategories":
        return <SubSubcategoriesTab />;
      default:
        return <div>Виберіть вкладку</div>;
    }
  };

  return (
    <div className="manage-categories">
      <h1 className="manage-categories__title">Керування категоріями</h1>

      <div className="manage-categories__tabs">
        <button
          onClick={() => setActiveTab("categories")}
          className={`manage-categories__tabs__button ${
            activeTab === "categories" ? "manage-categories__tabs__button--active" : ""
          }`}
        >
          Категорії
        </button>

        <button
          onClick={() => setActiveTab("subcategories")}
          className={`manage-categories__tabs__button ${
            activeTab === "subcategories" ? "manage-categories__tabs__button--active" : ""
          }`}
        >
          Суб Категорії
        </button>

        <button
          onClick={() => setActiveTab("subsubcategories")}
          className={`manage-categories__tabs__button ${
            activeTab === "subsubcategories" ? "manage-categories__tabs__button--active" : ""
          }`}
        >
          Суб-Суб Категорії
        </button>
      </div>

      <div className="manage-categories__content">{renderContent()}</div>
    </div>
  );
};

export default ManageCategories;
